export enum SectionType{
    Intro = "Intro",
    Verse = "Verse",
    PreChorus = "Pre-Chorus",
    Chorus = "Chorus",
    PostChorus = "Post-Chorus",
    Bridge = "Bridge",
    Outro = "Outro"
}